<template>
    <a-select :placeholder="$props.placeholder" @change="handleChange">
      <a-select-option :value="item.id" v-for="item in data" :key="item.id">
        {{ item.displayname }}
      </a-select-option>
    </a-select>
</template>

<script type="text/ecmascript-6">
  import { Select } from 'ant-design-vue'
  import { getDictionary } from '../api'
  export default {
    components: {
      ASelect: Select,
      ASelectOption: Select.Option,
    },
    data() {
      return {
        data: [],
      }
    },
    props: ['code', 'placeholder'],
    mounted() {
      getDictionary(this.code).then(res => {
        if(res.success) {
          this.data = res.data
        }
      })
    },
    methods: {
      handleChange(value) {
        this.$emit('change', value)
      },
    }
  }
</script>

<style>

</style>
